import { Autocomplete, Button, Chip, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useImmer } from "use-immer";
import DataTable from "../DataGrid/DataGrid";
import { APP_BASE_URL, ASSET_CODAL_EXPIRE, extractFilters } from "../../Common/EndPoints";
import axios from "axios";
import toast from "react-hot-toast";
import { GridColDef } from "@mui/x-data-grid";
import { getLocalStorage, getParsedLocalStorage } from "../../Utils/storage-utils";
import { extractUserDataFromPermission } from "../../Utils/Utils";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./mis.scss"
import { useSearchParams } from "react-router-dom";
import { AutocompleteStationListPop } from "../AutocompleteStationListPop/AutocompleteStationListPop";
import { usePermissions } from "../../hooks/usePermissions";


export const expiryAssetsFixedColumns: GridColDef[] = [
  {
    field: "zone",
    headerName: "Zone",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "division",
    headerName: "Division",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "stn",
    headerName: "Station",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "assetType",
    headerName: "Asset Type",
    sortable: true,
    minWidth: 100,
    hideable: true,
    flex: 1,
  },
  {
    field: "software",
    headerName: "System",
    sortable: true,
    minWidth: 100,
    hideable: true,
    flex: 1,
    renderCell: (params) => params.value.code,
  },
  {
    field: "gearName",
    headerName: "Asset Name",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "componentName",
    headerName: "Component Name",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "make",
    headerName: "Make",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "model",
    headerName: "Model",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  // {
  //   field: "rfid",
  //   headerName: "RFID",
  //   sortable: true,
  //   minWidth: 150,
  //   hideable: true,
  //   flex: 1,
  // },

  {
    field: "doi",
    headerName: "Date of Installation",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  // {
  //   field: "dom",
  //   headerName: "Date of Maintenance",
  //   sortable: true,
  //   minWidth: 150,
  //   hideable: true,
  //   flex: 1,
  // },
  // {
  //   field: "doe",
  //   headerName: "Date of Expiry",
  //   sortable: true,
  //   minWidth: 150,
  //   hideable: true,
  //   flex: 1,
  // },
];

const initialState = {
  data: [],
  totalElements: 0,
};

const initialFilter = {
  page: 0,
  pageSize: 10,
  systems: [],
};

function MidlifeRehabilitation() {
  const [searchParams] = useSearchParams();
  const stationId = searchParams.get("stn_codes");
  const [state, setState] = useImmer(initialState);
  const [filters, setFilters] = useState<any>({
    ...initialFilter,
    customer: stationId?.split?.(",") || []
  });
  const [midlifeRehabilitationTableLoader, setMidlifeRehabilitationTableLoader] = useState(false);

  useEffect(() => {
    getMidlifeRehabilitationTableData();
  }, [filters]);

  const midlifeRehabilitationColumns = useMemo<GridColDef[]>(() => {
    return [
      //   {
      //     field: "action",
      //     headerName: "Action",
      //     sortable: false,
      //     minWidth: 100,
      //     flex: 1,
      //     renderCell: (params) => {
      //       return (
      //         <IconButton onClick={() => {}}>
      //           <DeleteIcon />
      //         </IconButton>
      //       );
      //     },
      //   },
      ...expiryAssetsFixedColumns,
      {
        field: "midLifeExpire",
        headerName: "Mid Life Expire",
        sortable: true,
        minWidth: 150,
        hideable: true,
        flex: 1,
      },
    ];
  }, []);

  const getMidlifeRehabilitationTableData = async () => {
    try {

      setMidlifeRehabilitationTableLoader(true);
      const _filter: any = {
        ...filters,
        softwareIds: (filters?.systems || [])?.map((system: any) => system.systemId) || [],
      };
      delete _filter.systems;
      const url = `${APP_BASE_URL}${ASSET_CODAL_EXPIRE}?${extractFilters(_filter)}`;
      const res = await axios.get(url);
      if (res?.data?.data?.content) {
        setState((state) => {
          state.data = res.data.data.content;
          state.totalElements = res.data.data?.totalElements || 0;
        });
      }
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong");
        return;
      }
      toast.error("Something went wrong");
    } finally {
      setMidlifeRehabilitationTableLoader(false);
    }
  };

  return (
    <div className="page-container--card">
      <div className="flex justify-between">
        <Typography variant="h6" sx={{ fontWeight: "bold" }} textAlign={"start"}>
          Midlife Rehabilitation
        </Typography>
      </div>

      <MidlifeRehabilitationFilter filter={filters} onFilter={setFilters} initialFilters={initialFilter} />

      <DataTable
        tableInfo={{
          id: `midlife-rehabilitation-table`,
          label: `Midlife Rehabilitation`,
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}
        loading={midlifeRehabilitationTableLoader}
        rows={state.data}
        columns={midlifeRehabilitationColumns}
        rowCount={state.totalElements}
        pageSize={filters.pageSize}
        pageSizeChange={(pageSize: number) =>
          setFilters(() => ({
            ...filters,
            pageSize,
          }))
        }
        pageIndex={filters.page}
        pageChange={(page: number) =>
          setFilters(() => ({
            ...filters,
            page,
          }))
        }
        hideExportPDF={true}
        paginationMode="server"
      />
    </div>
  );
}

export default MidlifeRehabilitation;

type IFilter = {
  filter: any;
  onFilter: any;
  initialFilters: any;
};

const MidlifeRehabilitationFilter: React.FC<IFilter> = ({ filter, onFilter, initialFilters }) => {
  const [privateFilter, setPrivateFilter] = useImmer(filter);
  const system_options = useMemo(() => {
    const systems = getParsedLocalStorage("systems_list", []);
    return systems.map((system: any) => ({
      systemId: system.id,
      systemName: system.code,
    }));
  }, []);

  const { outerToInnerKeys: divisionLists, innerToCustomerNames: station, outermostKeys: zone } = usePermissions();

  // const { divisionLists, station, zone } = useMemo(() => {
  //   const divisionList = getLocalStorage("permissions", []);
  //   const {
  //     outermostKeys: zone,
  //     outerToInnerKeys: divisionLists,
  //     innerToCustomerNames: station,
  //     customerNameToId: customer_name_to_id,
  //   }: any = extractUserDataFromPermission(JSON.parse(divisionList));

  //   return {
  //     divisionLists,
  //     station,
  //     zone,
  //     customer_name_to_id,
  //   };
  // }, []);

  // const sections = useMemo(() => {
  //   if (privateFilter?.zone) {
  //     return divisionLists[privateFilter.zone] || [];
  //   }
  //   return [];
  // }, [privateFilter?.zone]);

  useEffect(() => {
    const filteredStations = privateFilter.customer.filter((stn: any) => Object.values(station).flat().includes(stn));
    setPrivateFilter((draft: any) => {
      draft.customer = filteredStations;
    });
    // when selected station removed after removing station from global filter. 
    // if(privateFilter.customer.length !== filteredStations.length) {
    onFilter({
      ...privateFilter,
      customer: filteredStations,
    });
    // }
  }, [station]);

  const filteredStations = useMemo(() => {
    // if (privateFilter?.division) {
    //   return station[privateFilter.division] || [];
    // }
    // return [];
    if (!station) return [];
    return (Object.values(station) || []).flat();
  }, [station]);

  const onChangeFilter = (name: string, value: any | any[]) => {
    setPrivateFilter((draft: any) => {
      draft[name] = value;
    });
  };

  return (
    <div className="filters-container">
      {/* <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={zone}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Division" placeholder="Division" />
        )}
        getOptionLabel={(customer) => customer}
        isOptionEqualToValue={(option, value) => option === value}
        value={privateFilter?.zone || null}
        onChange={(_, newValue) => {
          onChangeFilter("zone", newValue || "");
          onChangeFilter("division", "");
          onChangeFilter("customer", "");
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={sections}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Section" placeholder="Section" />
        )}
        getOptionLabel={(option) => option}
        isOptionEqualToValue={(option, value) => option === value}
        value={privateFilter?.division || null}
        onChange={(_, newValue) => {
          onChangeFilter("division", newValue || "");
          onChangeFilter("customer", "");
        }}
      /> */}

      <Autocomplete
        size="small"
        disableCloseOnSelect
        multiple
        className="filter-input auto-complete"
        options={filteredStations}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Stations" placeholder="Stations" />
        )}
        getOptionLabel={(option) => option}
        isOptionEqualToValue={(option, value) => option === value}
        value={privateFilter?.customer || []}
        onChange={(_, newValue) => {
          onChangeFilter("customer", newValue || []);
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0]} {...getTagProps({ index: 0 })} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />

      <Autocomplete
        size="small"
        multiple
        className="filter-input auto-complete"
        disableCloseOnSelect
        limitTags={2}
        isOptionEqualToValue={(option, value) => option.systemId === value.systemId}
        getOptionKey={(option) => option.systemId}
        value={privateFilter.systems ?? []}
        options={system_options}
        getOptionLabel={(option) => option.systemName}
        onChange={(_, value) =>
          setPrivateFilter((prev: any) => ({
            ...prev,
            systems: value,
          }))
        }
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].systemName} {...getTagProps({ index: 0 })} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
        renderInput={(params) => <TextField {...params} label="Systems" placeholder="Systems" />}
      />

      <TextField
        size="small"
        fullWidth
        className="filter-input"
        label="Component Name"
        placeholder="Component Name"
        value={privateFilter?.componentName || ""}
        onChange={(e) => {
          onChangeFilter("componentName", e.target.value);
        }}
      />

      <TextField
        size="small"
        fullWidth
        className="filter-input"
        label="Asset Name"
        placeholder="Asset Name"
        value={privateFilter?.gearName || ""}
        onChange={(e) => {
          onChangeFilter("gearName", e.target.value);
        }}
      />

      <TextField
        size="small"
        fullWidth
        className="filter-input"
        label="Make"
        placeholder="Make"
        value={privateFilter?.make || ""}
        onChange={(e) => {
          onChangeFilter("make", e.target.value);
        }}
      />

      <TextField
        size="small"
        fullWidth
        className="filter-input"
        label="Model"
        placeholder="Model"
        value={privateFilter?.model || ""}
        onChange={(e) => {
          onChangeFilter("model", e.target.value);
        }}
      />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Mid Life Expire Date Upto"
          value={privateFilter?.midLifeExpire || null}
          renderInput={(params) => <TextField {...params} size="small" />}
          onChange={(value: any, keyboardInputValue?: string) => {
            const keyName = "midLifeExpire";

            if (keyboardInputValue) {
              if (!dayjs(value).isValid()) {
                return;
              }
              onChangeFilter(keyName, dayjs(value).format("YYYY-MM-DD"));
            } else {
              onChangeFilter(keyName, dayjs(value).format("YYYY-MM-DD"));
            }
          }}
        />
      </LocalizationProvider>
      <Button variant="contained" onClick={() => onFilter(privateFilter)}>
        Filter
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          onFilter(initialFilters);
          setPrivateFilter(initialFilters);
        }}
      >
        Clear
      </Button>
    </div>
  );
};
